<template>
    <h1 class="fat headline" v-html="title"></h1>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'

    function getHost() {
        return window.location.host;
    }

    function isAt() {
        return window.location.host.toLowerCase().endsWith(".at");
    }

    @Component()
    export default class Headline extends Vue {
        get title() {
            return isAt() ? "WERSGLAUBT.AT" : "WERSGLAUBT.DE";
        }
    }
</script>
<style scoped lang="scss">
    .headline {
        text-align: center;
        font-size: 10vw;
        font-weight: 900;
        text-transform: uppercase;

        @media screen and (min-width: 660px) {
            font-size: 66px;
        }
    }
</style>
